export function PodSaveReq() {
  this.PODNr = "";
  this.KodReference = "";
  this.Pesha = "";
  this.Cope = "";
  this.KodPershkrimi = "";
  this.KodiProduktit = "";
  this.KlientSubjektDergues = "";
  this.KlientSubjektMarres = "";
  this.KushPaguan = "";
  this.MenyrePagese = "";
  this.Marresi = "";
  this.TelMarresi = "";
  this.AdresaMarresi = "";
  this.KodiPostarMarres = "";
  this.QytetiMarres = "";
  this.ShtetiMarres = "";
  this.TelDerguesi = "";
  this.AdresaDerguesi = "";
  //this.KodiPostarDerguesi = "";
  this.QytetiDergues = "";
  this.ShtetiDergues = "";
  this.KlientSubjektID = "";
  this.MonedhaKP = "";
  this.Pershkrime = "";
  this.Komente = "";
  this.Levizja = "";
  this.KodiLevizjes = "";
  this.Drejtimi = "";
  this.Brandi = "";
  this.KodiSherbimit = "";
  this.Korrieri = "";
  this.Destinacion = "";
  this.UsernameID = "";
  // this.VleraExtra = "";
  this.MonedhaCmimiBaze = "";
  this.MonedhaExtra = "";
  this.CmimiBaze = "";
  this.CmimiBazeTry = "";
  this.Totali = "";
  this.ShumaSherbimeExtra = "";
  this.Token = "";
  this.username = "";
  this.Derguesi = "";
  this.AgjensiDestinacion = "";
  this.isFshat=false;
  this.QytetFshat = "";
  this.ShteseLekeCheck = false;
  this.KundrejtPageseLekeCheck = false;
  this.ShteseLekeVlera = "";
  this.AgjensiTranzit = "";
  this.AgjensiOrigjineID = "";
  this.isNational = false;
  this.hasZbritje = false;
  this.hasZbritje2 = false;
  this.hasConfirmed = false;
  this.Terminal ="";
}
